// 重构后的文本转点云Hook - 重新导出简化版本
// 为了保持向后兼容，这里重新导出新的模块化Hook

export { 
  useTextToPointCloud,
  type TextToPointCloudConfig,
  type PointCloudState,
  type GenerationState,
  type TextRenderResult,
  type CrystalDimensions,
  DEFAULT_CONFIG
} from "../text-to-pointcloud";